import util from '@bmp-vue/core/api/util'

const controller = 'Portal'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetCustomJSON: function (codigo) {
    return util.Axios.Get(controller + '/GetCustomJSON', codigo)
  },
  GetAllByEmail: function (email) {
    return util.Axios.Get(controller + '/GetAllByEmail', email)
  },
  GetAllByUser: function (email) {
    return util.Axios.Get(controller + '/GetAllByUser', email)
  },
  PutCustomJSON: function (id, dto) {
    return util.Axios.Put(controller + '/PutCustomJSON', id, dto)
  },
  DownloadImagens: function (id) {
    return util.Axios.GetBlob(controller + '/DownloadImagens/' + id)
  },
  GetByCodigoIntegracao: function (codigo) {
    return util.Axios.Get(controller + '/GetByCodigoIntegracao/' + codigo)
  },
  GetByCodigoIntegracaoDbs: function (codigo) {
    return util.Axios.Get(controller + '/GetByCodigoIntegracaoDbs/' + codigo)
  },
  GetSVG: function (url) {
    return util.Axios.Get(controller + `/svgContent?url=${url}`)
  },
  UpdateSVGColor (caminhoS3, arquivo, oldColor, newColor) {
    return util.Axios.Post(controller + '/UpdateSVGColor', { caminhoS3, arquivo, oldColor, newColor })
  },
  DeleteCustomJSON (codigo) {
    return util.Axios.Delete(controller + '/DeleteCustomJSON', codigo);
  }
})
